import React from 'react';
import './App.css';
import {
  isMobile,
  MainWr, PlatformMessagesWrapper,
} from '@pascal/pascal-core';
import { GeneralPopups } from './conatiners/generalPopups';
import { MobileRoutes } from './routes/mobile.routes';
import { WebRoutes } from './routes/web.routes';
import { BrowserRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import SoundWatcher from './components/soundContent';
import { LoadingContainer } from './conatiners/loading';
import { SocketConnection } from './core/init/socketConnection';

const App = observer(() => {

  // remove comment below to turn on Halloween Mode
  // useEffect(() => {
  //   document
  //     .getElementById('root')
  //     .classList.add(isMobile() ? 'halloween-mode-mobile' : 'halloween-mode-web');
  // }, [])

  return (
    <BrowserRouter>
      <MainWr>
        <LoadingContainer>
          <PlatformMessagesWrapper>
            <SocketConnection/>
          </PlatformMessagesWrapper>
          <GeneralPopups />
          {isMobile() ? <MobileRoutes /> : <WebRoutes />}
        </LoadingContainer>
        <SoundWatcher />
      </MainWr>
    </BrowserRouter>

  );
});

export default App;
